import API from 'services/API';

export default function getPdfInfo() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/insuranceTaxes/v2',
  });
}
